import React from 'react';
import { makeStyles } from 'tss-react/mui';
import WidgetPaper from '@components/widgets/display-widget/WidgetPaper';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';
import { MAIN_THEME } from '@styles';

interface IPolicyMedicalGroupDetailsWidgetProps {
  lovs: Record<string, Record<string, string>>;
}

const useStyles = makeStyles()(() => ({
  container: {
    width: '100%',
    marginTop: '1em',
  },
  section: {
    padding: '23px 0 25px',
  },
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: `repeat(1, 100%)`,
    gap: '2%',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  paragraph: {
    fontSize: MAIN_THEME.fontSize.rg,
    lineHeight: '20px',
    margin: '0 0 10px',
    fontFamily: MAIN_THEME.font.bold,
  },
  list: {
    fontSize: MAIN_THEME.fontSize.rg,
    lineHeight: '20px',
    margin: '0 0 10px',
    fontFamily: MAIN_THEME.font.regular,
  },
}));

const PolicyMedicalGroupDetailsWidget: React.FC<
  IPolicyMedicalGroupDetailsWidgetProps
> = ({ lovs }) => {
  const { classes } = useStyles();

  return (
    <WidgetPaper>
      <WidgetSection
        title="Group Medical Details "
        hasTitleSpecificDesign={false}
        classes={{
          container: classes.section,
        }}
        useSeparator={false}
      >
        <div className={classes.fieldRow}>
          <div>
            <p className={classes.paragraph}>
              The plan selected includes the below covers:
            </p>
            <ul>
              {Object.values(lovs.policyCovers).map((cover) => (
                <li className={classes.list} key={cover}>
                  {cover}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </WidgetSection>
    </WidgetPaper>
  );
};

export default PolicyMedicalGroupDetailsWidget;
